import { DialogOpenEvent } from '@theme/dialog';

const marker = document.querySelector('script[data-ov-search-loader]');
const modal = document.getElementById('search-modal');
const component = modal?.querySelector('predictive-search-component');
const input = component?.querySelector('[ref="searchInput"]');

if (marker && modal && component && input) {
  let pending;
  let missedInput = false;
  const intentController = new AbortController();

  const load = () => {
    if (pending) return pending;
    pending = import(marker.dataset.source)
      .then(() => {
        intentController.abort();
        if (missedInput && input.value.trim()) {
          component.search({ inputType: 'insertText' });
        }
      })
      .catch((error) => {
        pending = undefined;
        console.warn('[OLD VEGAS search] Unable to load predictive search:', error);
      });
    return pending;
  };

  const onIntent = (event) => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('button, a');
    if (trigger?.getAttribute('on:click')?.includes('#search-modal/')) load();
  };

  const options = { capture: true, passive: true, signal: intentController.signal };
  document.addEventListener('pointerdown', onIntent, options);
  document.addEventListener('focusin', onIntent, options);
  input.addEventListener('focus', load, { signal: intentController.signal });
  input.addEventListener('input', () => {
    missedInput = true;
    load();
  }, { signal: intentController.signal });
  modal.addEventListener(DialogOpenEvent.eventName, load);

  document.addEventListener('keydown', (event) => {
    if (!event.metaKey || event.key !== 'k' || customElements.get('predictive-search-component')) return;
    event.preventDefault();
    load();
    customElements.whenDefined('dialog-component').then(() => modal.toggleDialog());
  });

  if (modal.querySelector('dialog[open]')) load();
}
